<template>
    <!-- 'chosen-label':  isActive, -->
    <div class="checkout-choice" :class="{'disabled-label': isDisabled}"> 
		<BaseRadio
			:name="name"
			:activeClass="getRadioClass()"
			:click="clickHandler"
			:ariaLabel="name || ariaLabel"
			:aria-checked="isActive"
			:aria-disabled="isDisabled">
			<slot></slot>
		</BaseRadio>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: ""
        },
        isActive: {
            type: Boolean,
            default: false
        },
        clickHandler: {
            type: Function,
            default: null
        },
        isDisabled: {
            type: Boolean, 
            default: false
		},
		ariaLabel: {
			type: String,
			default: '',
		}
    },
    methods: {
        getRadioClass() {
            if (this.isDisabled) {
                return 'disabled';
            } else if (this.isActive) {
                return 'selected';
            } else {
                return '';
            }
        }
    }
}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/checkout/CheckoutChoice.vue